import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";

const getUserTypes: EvokeAction<AppState, AppActions> = async store => {
  try {
    const userTypes = await api.get(`pos-users/types`);
    
    await store.update(state => {
      state.userTypes = userTypes;
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const userTypeActions = {
  getUserTypes
};
